var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MuiTooltip from "@mui/material/Tooltip";
import { Box } from "@mui/material";
import { COLORS, DEFAULT_SHADOW2 } from "../../../constants/colors";
import { useMemo } from "react";
import TooltipLinks from "./components/TooltipLinks";
import TooltipTags from "./components/TooltipTags";
var Tooltip = function (_a) {
    var children = _a.children, _b = _a.testId, testId = _b === void 0 ? "" : _b, _c = _a.arrow, arrow = _c === void 0 ? true : _c, _d = _a.enterTouchDelay, enterTouchDelay = _d === void 0 ? 0 : _d, tooltipColor = _a.tooltipColor, links = _a.links, title = _a.title, // pass empty string when links or tags variation
    tags = _a.tags, _e = _a.wrap, wrap = _e === void 0 ? true : _e, rest = __rest(_a, ["children", "testId", "arrow", "enterTouchDelay", "tooltipColor", "links", "title", "tags", "wrap"]);
    var getColors = function () {
        switch (tooltipColor) {
            case "sayBlue":
                return {
                    bgcolor: COLORS.SAY_COBALT,
                    color: COLORS.WHITE,
                };
            case "blue":
                return {
                    bgcolor: COLORS.SHADED_COBALT,
                    color: COLORS.WHITE,
                };
            case "white":
                return {
                    bgcolor: COLORS.WHITE,
                    color: COLORS.BLACK,
                    border: "1px solid ".concat(COLORS.P_OUTLINE),
                    boxShadow: DEFAULT_SHADOW2,
                };
            default:
                return {
                    bgcolor: COLORS.P_MED_EMPHASIS,
                    color: COLORS.WHITE,
                };
        }
    };
    var colorStyles = useMemo(getColors, [tooltipColor]);
    var content = wrap ? _jsx(Box, { children: children }) : children;
    var tooltipTitle = (function () {
        if (links === null || links === void 0 ? void 0 : links.length) {
            return _jsx(TooltipLinks, { links: links });
        }
        if (tags === null || tags === void 0 ? void 0 : tags.length) {
            return _jsx(TooltipTags, { tags: tags });
        }
        return title;
    })();
    return (_jsx(MuiTooltip, __assign({ "data-testid": "Tooltip-".concat(testId), arrow: arrow, enterTouchDelay: enterTouchDelay, title: tooltipTitle, componentsProps: {
            tooltip: {
                sx: __assign(__assign({}, colorStyles), { padding: (links === null || links === void 0 ? void 0 : links.length) ? "0" : "4px 12px", fontSize: "0.875rem", letterSpacing: "0px", lineHeight: "1.25rem", maxWidth: "300px" }),
            },
            arrow: {
                sx: {
                    color: colorStyles.bgcolor,
                    "&:before": {
                        border: colorStyles.border,
                        boxShadow: colorStyles.boxShadow,
                    },
                },
            },
        } }, rest, { children: content })));
};
export default Tooltip;
